export default __webpack_public_path__ + "static/media/new-6.1f76ffe7.png";